@if (links.length > 0 || items.length > 0) {
  <div class="global-footer__links">
    @for (i of links; track $index) {
      <a class="global-footer__links-item" (click)="to(i)" [innerHTML]="i._title"></a>
    }
    @for (i of items; track $index) {
      <a class="global-footer__links-item" (click)="to(i)">
        <ng-container *ngTemplateOutlet="i.host" />
      </a>
    }
  </div>
}
<div class="global-footer__copyright">
  <ng-content />
</div>
